// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__Xq0ml","scroll":"Nav_scroll__MTAXY"};